const EsignDetails = () => {
    return (
        <div>
            <p>E-sign Details </p>
        </div>
    )
};

export default EsignDetails